export default class LiveInputsBooleanInput {
  constructor(liveInputs) {
    this.liveInputs = liveInputs
    this.handleChangeEvent = this.handleChangeEvent.bind(this)
    this.initializeListeners()
  }

  inputFilter() {
    return "[data-behaviour~='live-inputs-boolean-input']"
  }

  initializeListeners() {
    this.liveInputs.on('change', this.inputFilter(), this.handleChangeEvent)
  }

  handleChangeEvent(event) {
    const $input = $(event.target)
    const value = $input.is(':checked')
    this.liveInputs.update($input, { value })
    $input.focus()
    this.liveInputs.setActiveElement($input)
  }

  teardown() {
    this.liveInputs.off('change', this.inputFilter(), this.handleChangeEvent)
  }
}
